// src/components/Navbar.jsx
import React, { useState, useEffect, useRef } from "react";
import { ref, get } from "firebase/database";
import { database } from "../firebaseConfig";
import "./Navbar.css";

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [navbarConfig, setNavbarConfig] = useState(null);
    const navbarRef = useRef(null);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    useEffect(() => {
        const fetchNavbarConfig = async () => {
            try {
                const snapshot = await get(ref(database, "navbarConfig"));
                if (snapshot.exists()) {
                    setNavbarConfig(snapshot.val());
                }
            } catch (error) {
                console.error("Error fetching Navbar config:", error);
            }
        };
        fetchNavbarConfig();
    }, []);

    // Build the gradient background from Firebase settings
    const backgroundStyle = navbarConfig
        ? {
            background: `linear-gradient(${navbarConfig.direction}, ${navbarConfig.colors.join(", ")})`,
        }
        : {};

    // Close the menu if a click occurs outside the navbar
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuOpen && navbarRef.current && !navbarRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);

    return (
        <header className="navbar" style={backgroundStyle} ref={navbarRef}>
            <div className="navbar-container">
                <div className="navbar-logo">
                    {navbarConfig && navbarConfig.showLogo && navbarConfig.logoImageUrl ? (
                        <a href="/">
                            <img
                                src={navbarConfig.logoImageUrl}
                                alt="Logo"
                                className="navbar-logo-img"
                            />
                        </a>
                    ) : (
                        <a href="/"></a>
                    )}
                </div>

                {/* Toggle button (Hamburger menu) */}
                <button className="menu-toggle" onClick={toggleMenu}>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </button>

                {/* Navigation Links */}
                <nav className={`nav-links ${menuOpen ? "active" : ""}`}>
                    <a href="/" className="mx-2">Home</a>
                    <a href="/about" className="mx-2">About</a>
                    <a href="/OurProducts" className="mx-2">Our Products</a>
                    <a href="/contact" className="mx-2">Contact</a>
                </nav>
            </div>
        </header>
    );
};

export default Navbar;
